import { Helmet } from 'react-helmet-async'

export function FAQHelmet() {
  const siteUrl = 'https://www.anizone.co.il/faq'
  const siteName = 'AniZone'
  const title = 'שאלות ותשובות על אנימה ומנגה – כל מה שצריך לדעת | AniZone'
  const description =
    'ריכזנו עבורכם מעל 100 שאלות ותשובות מקיפות על עולם האנימה והמנגה – כולל הסברים למתחילים, טיפים למתקדמים וידע עמוק למומחים. מונחים, ז’אנרים, שיטות צפייה, תעשייה ועוד.'
  const image =
    'https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/uploads/2025/05/logo-1747045147075.webp'

  return (
    <Helmet>
      {/* 🧠 SEO בסיסי */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content="שאלות על אנימה, אנימה למתחילים, מנגה, הגדרות אנימה, שאלות ותשובות אנימה, FAQ אנימה, AniZone"
      />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={siteUrl} />

      {/* 🌐 Open Graph */}
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:site_name" content={siteName} />

      {/* 🐦 Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={siteUrl} />

      {/* 🧩 JSON-LD Schema.org FAQPage */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'מהי אנימה (Anime)?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'אנימה היא סגנון אנימציה יפני המתאפיין בהבעות פנים מוגזמות, צבעוניות וסגנון ציור ייחודי. היא כוללת מגוון ז’אנרים ונצרכת בכל העולם.',
                },
              },
              {
                '@type': 'Question',
                name: 'מה ההבדל בין אנימה למנגה?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'אנימה היא סדרת אנימציה לצפייה, בעוד שמנגה היא קומיקס לקריאה. בדרך כלל האנימה מבוססת על מנגה אך יכולה לכלול שינויים.',
                },
              },
              {
                '@type': 'Question',
                name: 'מה זה פילרים (Filler)?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'פילרים הם פרקים שאינם מופיעים במנגה המקורית ונוספו לאנימה לצורך הארכת זמן או הרחבת העלילה.',
                },
              },
              {
                '@type': 'Question',
                name: 'האם כל האנימות מתאימות לכל הגילאים?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'לא. קיימים דירוגי גיל – חלק מהסדרות מתאימות לילדים ואחרות כוללות תכנים בוגרים כמו אלימות או נושאים מורכבים.',
                },
              },
              {
                '@type': 'Question',
                name: 'מה זה דאב ו־סאב באנימה?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Sub הוא תרגום כתוביות – האנימה נשארת ביפנית עם כתוביות. Dub הוא דיבוב – תרגום קולי לשפה אחרת כמו אנגלית.',
                },
              },
            ],
          }),
        }}
      />
    </Helmet>
  )
}
